import React from "react";
import ReactDom from "react-dom";
import { Dialog, RaisedButton, FlatButton, TextField } from "material-ui";
import Card from "card";
import Payment from "payment";
import Swipe from "card-swipe";

class CreditCardEntry extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      number: "",
      name: "",
      expiry: "",
      cvc: "",
      isWaitingForSwipe: false,
      rawSwipe: "",
      isSwiped: false
    };

    this.getPaymentDetails = this.getPaymentDetails.bind(this);
    this.reset = this.reset.bind(this);

    this.onChange = this.onChange.bind(this);

    this.startSwipe = this.startSwipe.bind(this);
    this.onSwipeInputChange = this.onSwipeInputChange.bind(this);
    this.onSwipeInputBlur = this.onSwipeInputBlur.bind(this);
    this.onSwipeInputKeyDown = this.onSwipeInputKeyDown.bind(this);
    this.onSwipeCancel = this.onSwipeCancel.bind(this);
    this.onSwipe = this.onSwipe.bind(this);
  }

  componentDidMount() {
    this.card = new Card({
      form: ReactDom.findDOMNode(this.form),
      container: ReactDom.findDOMNode(this.cardPreview),
      debug: true
    });

    this.scanner = new Swipe.Scanner();
    new Swipe({
      scanner: this.scanner,
      onScan: this.onSwipe
    });
  }

  getPaymentDetails() {
    let [month, year] = this.state.expiry
        ? this.state.expiry.split(/\s*\/\s*/)
        : [null, null],
      paymentDetails = {
        name: this.state.name,
        number: this.state.number,
        cvc: this.state.isSwiped ? undefined : this.state.cvc, // Swipe doesn't have CVC
        exp_month: month,
        exp_year: year
      };

    return paymentDetails;
  }

  reset() {
    this.setState({
      number: null,
      name: null,
      expiry: null,
      cvc: null
    });
  }

  onChange() {
    if (this.props.onChange) {
      this.props.onChange(this.getPaymentDetails());
    }
  }

  set(fields) {
    this.setState(fields);
  }

  startSwipe() {
    this.setState(
      {
        isWaitingForSwipe: true,
        rawSwipe: ""
      },
      () => {
        this.swipeInput.focus();
      }
    );
  }

  onSwipeInputChange(e) {
    this.setState({ rawSwipe: e.target.value });
  }

  onSwipeInputBlur() {
    // Don't let focus switch from the swipe while waiting for swipe
    if (this.state.isWaitingForSwipe) {
      setTimeout(() => {
        this.swipeInput.focus();
      }, 10);
    }
  }

  onSwipeInputKeyDown(e) {
    if (e.keyCode === 13) {
      try {
        this.scanner.input(this.state.rawSwipe);
      } catch (e) {
        // fall through
        // just want 'em to swipe again
      }
    }
  }

  onSwipeCancel() {
    this.setState({
      isWaitingForSwipe: false
    });
  }

  onSwipe(swipeInfo) {
    // Ignore empty swipes
    if (!Object.keys(swipeInfo).length) {
      return;
    }

    this.setState(
      {
        number: swipeInfo.account,
        name: swipeInfo.name,
        expiry: `${swipeInfo.exp_month}/${swipeInfo.exp_year}`,
        isWaitingForSwipe: false,
        isSwiped: true
      },
      () => {
        this.onChange();
      }
    );

    // Force card re-render
    let e = document.createEvent("HTMLEvents");
    e.initEvent("keyup", false, true);
    Array.prototype.slice
      .call(this.form.getElementsByTagName("input"))
      .forEach(node => {
        node.dispatchEvent(e);
      });
  }

  onFieldChange(key, e) {
    let { value } = e.target;

    // Manually format + dispatch cardType change since not fired on Android Chrome
    // https://github.com/jessepollak/card/issues/199
    if (key === "number") {
      value = Payment.fns.formatCardNumber(value);
      try {
        const cardType = Payment.fns.cardType(value);
        const ev = new CustomEvent("payment.cardType", { detail: cardType });
        this._cardNumberField.input.dispatchEvent(ev);
      } catch (exception) {
        // silently swallow IE11 exceptions
      }
    } else if (key === "expiry") {
      let trimmed = value.trim(),
        firstCharZeroOrOne = trimmed[0] === "0" || trimmed[0] === "1";

      if (
        (trimmed.length === 1 && !firstCharZeroOrOne) ||
        (trimmed.length == 2 && firstCharZeroOrOne)
      ) {
        value = trimmed + " / ";
      }
    }

    this.setState(
      {
        [key]: value
      },
      () => {
        this.onChange();
      }
    );
  }

  getStyles() {
    return {
      swipeInput: {
        // Invisible - this is populated by the USB card reader
        width: 0,
        overflow: "hidden"
      },
      swipeButton: {
        marginBottom: 20,
        marginLeft: 5,
        marginRight: 5
      },
      cardPreview: {
        float: "right",
        maxWidth: "100%",
        overflow: "hidden"
      },
      form: {
        marginRight: 10
      },
      field: {
        margin: 2
      },
      actions: {
        marginTop: 10
      },
      error: {
        color: "#FF4136"
      }
    };
  }

  render() {
    var styles = this.getStyles();

    return (
      <div style={this.props.style}>
        <div style={styles.swipeInput}>
          <input
            id="CreditCardEntry--input"
            ref={ref => (this.swipeInput = ref)}
            type="text"
            onChange={this.onSwipeInputChange}
            onBlur={this.onSwipeInputBlur}
            onKeyDown={this.onSwipeInputKeyDown}
            value={this.state.rawSwipe}
          />
        </div>
        <Dialog
          title="Swipe card"
          actions={[
            <FlatButton
              label="Cancel"
              primary={true}
              onTouchTap={this.onSwipeCancel}
            />
          ]}
          modal={false}
          open={this.state.isWaitingForSwipe}
          onRequestClose={this.onSwipeCancel}
        >
          Swipe the card now using any USB card reader.
        </Dialog>
        Click to{" "}
        <RaisedButton
          style={styles.swipeButton}
          label="Swipe card"
          onTouchTap={this.startSwipe}
        />{" "}
        or manually enter details below.
        <div>
          <div
            className="cardPreview"
            ref={ref => (this.cardPreview = ref)}
            style={styles.cardPreview}
          />
          <form ref={ref => (this.form = ref)} style={styles.form}>
            <TextField
              placeholder="Card number"
              name="number"
              disabled={this.state.isSwiped}
              value={this.state.number || ""}
              onKeyUp={this.onFieldChange.bind(this, "number")}
              onChange={this.onFieldChange.bind(this, "number")}
              ref={i => (this._cardNumberField = i)}
              pattern="\d*"
              type="tel"
              style={styles.field}
            />
            <TextField
              placeholder="Name on card"
              type="text"
              name="name"
              disabled={this.state.isSwiped}
              value={this.state.name || ""}
              onChange={this.onFieldChange.bind(this, "name")}
              style={styles.field}
            />
            <TextField
              placeholder="MM/YY"
              name="expiry"
              disabled={this.state.isSwiped}
              value={this.state.expiry || ""}
              onChange={this.onFieldChange.bind(this, "expiry")}
              pattern="\d*"
              type="tel"
              ref="cardExpiryField"
              style={styles.field}
            />
            {!this.state.isSwiped ? ( // Swipe doesn't have CVC
              <TextField
                placeholder="CVC"
                name="cvc"
                value={this.state.cvc || ""}
                onChange={this.onFieldChange.bind(this, "cvc")}
                pattern="\d*"
                type="tel"
                ref="cardCVCField"
                style={styles.field}
              />
            ) : (
              <div style={{ height: 48, width: 50 }} />
            )}
          </form>
        </div>
      </div>
    );
  }
}

export default CreditCardEntry;



// WEBPACK FOOTER //
// ./src/app/components/partials/credit-card-entry.jsx